import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActiveDiseasesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ActiveDiseasesQuery = { readonly __typename?: 'Query', readonly diseases: { readonly __typename?: 'DiseasesPage', readonly id: string, readonly items: ReadonlyArray<{ readonly __typename?: 'Disease', readonly uuid: string, readonly category?: string | null, readonly code?: string | null, readonly coding?: string | null, readonly categoryDisplayName?: string | null, readonly displayName: string, readonly keywords?: ReadonlyArray<string | null> | null } | null>, readonly categoryItems: ReadonlyArray<{ readonly __typename?: 'Category', readonly displayName: string, readonly value: string } | null> } };


export const ActiveDiseasesDocument = gql`
    query ActiveDiseases {
  diseases {
    id
    items {
      uuid
      category
      code
      coding
      categoryDisplayName
      displayName
      keywords
    }
    categoryItems {
      displayName
      value
    }
  }
}
    `;

/**
 * __useActiveDiseasesQuery__
 *
 * To run a query within a React component, call `useActiveDiseasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveDiseasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveDiseasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveDiseasesQuery(baseOptions?: Apollo.QueryHookOptions<ActiveDiseasesQuery, ActiveDiseasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveDiseasesQuery, ActiveDiseasesQueryVariables>(ActiveDiseasesDocument, options);
      }
export function useActiveDiseasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveDiseasesQuery, ActiveDiseasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveDiseasesQuery, ActiveDiseasesQueryVariables>(ActiveDiseasesDocument, options);
        }
export type ActiveDiseasesQueryHookResult = ReturnType<typeof useActiveDiseasesQuery>;
export type ActiveDiseasesLazyQueryHookResult = ReturnType<typeof useActiveDiseasesLazyQuery>;
export type ActiveDiseasesQueryResult = Apollo.QueryResult<ActiveDiseasesQuery, ActiveDiseasesQueryVariables>;